import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { ColorProvider } from "./context/ColorContext";
import { ThemeProvider } from "./context/ThemeContext";
import { ProtectedRoute, RequirePermission, RequireAdmin, RequireMaster } from "./components/ProtectedRoute";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import ResetPassword from "./pages/ResetPassword";
import Overview from "./pages/Overview";
import Grievances from "./pages/Grievances";
import GrievanceDetail from "./pages/GrievanceDetail";
import Statistics from "./pages/Statistics";
import AgentPortal from "./pages/AgentPortal";
import GrievantProfile from "./pages/GrievantProfile";
import AdminPortal from "./pages/AdminPortal";
import Messaging from "./pages/Messaging";
import Reports from "./pages/Reports";
import ActivityLog from "./pages/ActivityLog";
import SmsPrivacyPolicy from "./pages/SmsPrivacyPolicy";
import SmsTerms from "./pages/SmsTerms";
import { Toaster } from "./components/ui/sonner";
import { InstallPWA } from "./components/InstallPWA";

function App() {
  return (
    <div className="App">
      <ThemeProvider>
      <AuthProvider>
        <ColorProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/sms-privacy-policy" element={<SmsPrivacyPolicy />} />
            <Route path="/sms-terms" element={<SmsTerms />} />
            <Route path="/" element={<ProtectedRoute><Layout><RequirePermission perm="view"><Overview /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/:division/grievances" element={<ProtectedRoute><Layout><RequirePermission perm="view"><Grievances bucket="local" title="Local Grievances" eyebrow="Case Management" /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/:division/fwd-to-office" element={<ProtectedRoute><Layout><RequirePermission perm="view"><Grievances bucket="fwd_office" title="FWD to Office" eyebrow="Forwarded to Union Office" /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/:division/terminations" element={<ProtectedRoute><Layout><RequirePermission perm="view"><Grievances bucket="terminations" title="Terminations" eyebrow="Termination Cases" /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/:division/statistics" element={<ProtectedRoute><Layout><RequirePermission perm="statistics"><Statistics /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/:division/agents" element={<ProtectedRoute><Layout><RequirePermission perm="agents"><AgentPortal /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/grievances/:id" element={<ProtectedRoute><Layout><RequirePermission perm="view"><GrievanceDetail /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/grievants/:name" element={<ProtectedRoute><Layout><RequirePermission perm="view"><GrievantProfile /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute><Layout><RequireAdmin><AdminPortal /></RequireAdmin></Layout></ProtectedRoute>} />
            <Route path="/messaging" element={<ProtectedRoute><Layout><RequireAdmin><Messaging /></RequireAdmin></Layout></ProtectedRoute>} />
            <Route path="/reports" element={<ProtectedRoute><Layout><RequirePermission perm="statistics"><Reports /></RequirePermission></Layout></ProtectedRoute>} />
            <Route path="/activity" element={<ProtectedRoute><Layout><RequireMaster><ActivityLog /></RequireMaster></Layout></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        </ColorProvider>
        <Toaster position="top-right" />
        <InstallPWA />
      </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
